/* eslint-disable @stylistic/max-len */

const CheckMark = () => {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2643_5272)">
        <path
          d="M11 0C4.92 0 0 4.92 0 11C0 17.08 4.92 22 11 22C17.08 22 22 17.08 22 11C22 4.92 17.08 0 11 0ZM9.31 15.62L5.63 11.94L7.04 10.53L9.3 12.79L15 7.09L16.41 8.5L9.29 15.62H9.31Z"
          fill="#28D2D1"
        />
      </g>
      <defs>
        <clipPath id="clip0_2643_5272">
          <rect
            fill="white"
            height="22"
            width="22"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckMark;
